<template>
  <div>
    <AllReceivedSendOuts></AllReceivedSendOuts>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const AllReceivedSendOuts = defineAsyncComponent(() =>
  import("@/components/sendOuts/AllReceivedSendOuts")
);
export default {
  components: {
    AllReceivedSendOuts,
  },
};
</script>
